import { render, staticRenderFns } from "./InventorySearch.vue?vue&type=template&id=63d0779c&scoped=true&"
import script from "./InventorySearch.vue?vue&type=script&lang=js&"
export * from "./InventorySearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d0779c",
  null
  
)

export default component.exports